module.exports = __webpack_public_path__ + "static/media/49-portland.1b1b7b78.jpg";